import { http } from './http';
import type {
  CreateWorksiteRequest,
  PageResponse,
  WorksiteDetail,
  WorksiteFilter,
  WorksiteListItem,
  WorksiteStatus,
} from './types';

export const worksitesApi = {
  list(filter: WorksiteFilter = {}): Promise<PageResponse<WorksiteListItem>> {
    const params: Record<string, string | number> = {};
    if (filter.q)              params.q = filter.q;
    if (filter.status)         params.status = filter.status;
    if (filter.tag)            params.tag = filter.tag;
    if (filter.assigneeUserId) params.assigneeUserId = filter.assigneeUserId;
    params.page = filter.page ?? 0;
    params.size = filter.size ?? 20;
    if (filter.sort)           params.sort = filter.sort;
    return http.get<PageResponse<WorksiteListItem>>('/worksites', { params }).then(r => r.data);
  },

  get(id: string): Promise<WorksiteDetail> {
    return http.get<WorksiteDetail>(`/worksites/${id}`).then(r => r.data);
  },

  create(data: CreateWorksiteRequest): Promise<{ id: string }> {
    return http.post<{ id: string }>('/worksites', data).then(r => r.data);
  },

  update(id: string, data: CreateWorksiteRequest): Promise<void> {
    return http.put(`/worksites/${id}`, data).then(() => undefined);
  },

  updateStatus(id: string, status: WorksiteStatus): Promise<void> {
    return http.patch(`/worksites/${id}/status`, { status }).then(() => undefined);
  },

  archive(id: string): Promise<void> {
    return http.delete(`/worksites/${id}`).then(() => undefined);
  },
};
